import { fetchQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { prefetchInvoiceData } from 'Automations/watchtower/inbox/notifications/hooks/useInvoiceData'
import { apiQueryClient } from 'features/api/apiQueryClient'

/**
 * Warms the queries the email review preview (`EmailPreview`) reads beyond the
 * execution summary itself: the live customer (re-fetched by the template
 * resolver for variable resolution) and the merchant (the email's "from").
 */
export const prefetchEmailReviewPreview = ({
  customerId,
  invoiceId
}: {
  customerId: string
  invoiceId: string
}): Promise<unknown> =>
  Promise.all([
    fetchQuery(
      apiQueryClient,
      dashboard20240730Client.getMerchantForSequenceAccount
    ),
    prefetchInvoiceData({ invoiceId, customerId })
  ])
